import { render, staticRenderFns } from "./CardSeparator.vue?vue&type=template&id=25788c2c&scoped=true&"
import script from "./CardSeparator.vue?vue&type=script&lang=js&"
export * from "./CardSeparator.vue?vue&type=script&lang=js&"
import style0 from "./CardSeparator.vue?vue&type=style&index=0&id=25788c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25788c2c",
  null
  
)

export default component.exports
import {QSeparator} from 'quasar'
component.options.components = Object.assign({QSeparator}, component.options.components || {})
